import { ApiV3 } from '../../commonv3/api/ApiV3';

export const AdminApiV3 = new ApiV3('/admin/api_v3');
